
import firebase from '../../utils/firebase';
import 'firebase/firestore';
import types from '../../actions/types';
import moment from 'moment';
import 'moment/locale/es';

const db = firebase.firestore(firebase);

export const getClientes = async (numero_vendedor) =>{
  let clientes = [];
  numero_vendedor.forEach(async element => {
    await db.collection("clientes").where("VKBUR", "==", element)
    .get().then(function(querySnapshot) {
      querySnapshot.forEach(async function(doc) {
        let cliente = doc.data();
        let facturas = await getFacturas(cliente.KUNNR, "");
        cliente.facturas = facturas;
        clientes.push(cliente)
      });
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });
  });
  return clientes;
}

export const getTickets = async (numero_vendedor) =>{
  let tickets = [];
  await db.collection("tickets").where("vendedor", "==", numero_vendedor)
  .get().then(function(querySnapshot) {
    querySnapshot.forEach(async function(doc) {
      let ticket = doc.data();
      ticket.id_collection = doc.id;
      tickets.push(ticket)
    });
  })
  .catch(function(error) {
      console.log("Error getting documents: ", error);
  });
  return tickets;
}

export const getVendedor = async (vendedor_email) =>{
  let vendTMP = {}
  let docRef = db.collection("administrativos").where("SMTP_ADDR", "==",  vendedor_email)
  await docRef.get().then(function(querySnapshot) {
    querySnapshot.forEach(function(doc) {
      vendTMP = doc.data();
      return;
    });
  })
  .catch(function(error) {
    console.log("Error getting documents: ", error);
  });
  return vendTMP
}

export const getVendedores = async () =>{
  let administrativos = [];
  let docRef = db.collection("administrativos")
  await docRef.get().then(function(querySnapshot) {
    querySnapshot.forEach(function(doc) {
      let admin = doc.data();
      administrativos.push(admin)
      return;
    });
  })
  .catch(function(error) {
    console.log("Error getting documents: ", error);
  });
  return administrativos
}

export const getConfiguracion = async () =>{
  let configuracion = [];
  await db.collection("_configuraciones").doc("configuracion_cobro_web")
  .get().then(function(doc) {
    if (doc.exists) {
      configuracion = doc.data();
      configuracion.last_sync = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    } else {
      console.log("No such document!");
    }
  })
  .catch(function(error) {
    console.log("Error getting documents: ", error);
  });
  //console.log(configuracion)
  return configuracion;
}

export const getFacturas = async (cliente, ultima) =>{
  let facturas = [];
  let permitidas = ['RV'];
  //console.log("hola", cliente)
  await db.collection("facturas").where("KUNNR", "==", cliente).where("BELNR", ">", ultima)
  .get().then(function(querySnapshot) {
    querySnapshot.forEach(function(doc) {
      let factura = doc.data();
      factura.abono = "0";
      factura.tmp_saldo = 0;
      if( Number.parseFloat(factura.WRBTR) > 0 && permitidas.includes(factura.BLART) ){
        facturas.push(factura)
      }
    });
  })
  .catch(function(error) {
    console.log("Error getting documents: ", error);
  });
  return facturas;
}

export const setTicket =  async (info) =>{
  let mensaje = "";
  info.enFirebase= "1";
  await db.collection("tickets").doc(info.id_ticket).set(info)
  .then(function(resultado) {
    mensaje= types.REGISTRO_OK;
  })
  .catch(function(error) {
    mensaje= types.REGISTRO_FAILD + ": " + error;
  });
  return (mensaje)
}

export const updateTicket =  async (info) =>{
  let mensaje = "";
  let ticketRef = db.collection("tickets").doc(info.id_ticket);

  await ticketRef.update({
    enFirebase: info.enFirebase,
    cancelado: info.cancelado,
    actualizar: info.actualizar,
    fechaCancelado: info.fechaCancelado
  })
  .then(function() {
    mensaje = types.TICKET_DELETE;
    //console.log(resultado.id)
  })
  .catch(function(error) {
    mensaje = types.TICKET_DELETE_FAIL + ": " + error;
  });
  return (mensaje)
}

export const getLastTicket = async (numero_vendedor) =>{
  let ticket;
  //console.log("hola", numero_vendedor)
  await db.collection("tickets").where("vendedor", "==", numero_vendedor).orderBy("num_ticket", "desc").limit(1)
  .get().then(function(querySnapshot) {
    querySnapshot.forEach(async function(doc) {
      ticket = doc.data();
    });
  })
  .catch(function(error) {
      console.log("Error getting documents: ", error);
  });
  //console.log("ultimo ticket", ticket)
  return ticket;
}